// Router handle for non-component code (e.g. helpers/swalErrorPopup.js).
// index.jsx registers the createBrowserRouter instance here after creating it.
let router = null;

export const registerRouter = (r) => {
  router = r;
};

// Sends the user to the V2 connection-error screen. Returns false when no
// router is registered so the caller can fall back to the legacy popup.
// Already being on the screen counts as handled (parallel failing calls
// must not stack history entries).
export const redirectToConnectionError = () => {
  if (!router) return false;
  if (router.state.location.pathname !== "/connection-error") {
    router.navigate("/connection-error");
  }
  return true;
};
